import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import { useMakeupWorkRequest } from "../../hooks/useMakeupWorkRequest";
import useDebounce from "../../hooks/useDebounce";
import { useCategories } from "../../categorys/contract/index";
import toast from "react-hot-toast";
import { makeupWorkRequestCall } from "../../api/makeupWorkRequest";
import FormInfo from "./form/info";
import FormDetail from "./form/detail";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import FormApprove from "./form/approve";
import icontrash from "../../assets/images/product/trash.svg";
import DeleteDialog from "../../components/dialog/delete";
import iconBack from "../../assets/images/quailai.svg";

const TableOpenMakeupWorkRequest = ({ isRefetchingWithCreate }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenApprove,
    onOpen: onOpenApprove,
    onClose: onCloseApprove,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  const statusDatas = [
    {
      key: "PENDING",
      value: "Chưa duyệt",
    },
    {
      key: "REJECTED",
      value: "Không được phê duyệt",
    },
    {
      key: "APPROVED",
      value: "Đã được duyệt",
    },
  ];

  const [isEdit, setIsEdit] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [status, setStatus] = useState(null);
  const [dataApproveItem, setDataApproveItem] = useState(null);
  const [revertRow, setRevertRow] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const {
    makeupWorkRequestData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useMakeupWorkRequest(employeeId, status, startDate, endDate);

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);
  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Mã NV",
        key: "codeEmployee",
      },
      {
        label: "Tên NV",
        key: "nameEmployee",
      },
      {
        label: "Ảnh",
        key: "images",
      },
      {
        label: "Ngày nghỉ",
        key: "dayLeave",
      },
      {
        label: "Ghi chú",
        key: "note",
      },
      {
        label: "Tên người duyệt",
        key: "codeEmployeeConfirm",
      },
      {
        label: "Ngày tạo",
        key: "createdAt",
      },
    ],
    data: makeupWorkRequestData,
  };

  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsEdit(type);
    onOpen();
  };

  const handleOpenDelete = (data) => {
    setDataEdit(data);
    onOpenDelete();
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit; 
      await makeupWorkRequestCall.delete(id);
      await refetch();
      setDataEdit(null);
      onCloseDelete();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa TTKQ ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );
      const { id, status, images, ...dataFilter } = filteredData;

      delete dataFilter?.bookerId;
      delete dataFilter?.status;

      const imagesOpition = {};
      if (images && images.length > 0) {
        imagesOpition.images = images;
      } else {
        imagesOpition.images = [];
      }

      await makeupWorkRequestCall.update(id, {
        ...dataFilter,
        ...imagesOpition,
      });

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const submitStatus = async (status, id) => {
    if (status !== "APPROVED") {
      const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
      const dataFormat = {
        status: status,
      };
      try {
        await makeupWorkRequestCall.approve(id, dataFormat);
        await refetch();
        toast.success("Cập nhập trạng thái thành công");
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
      }
      toast.dismiss(toastEdit);
    } else {
      setDataApproveItem({
        status,
        id,
      });
      onOpenApprove();
    }
  };

  const onRevert = async () => {
    if (!revertRow) return;
    const toastId = toast.loading("Đang hoàn tác đơn ...");
    try {
      await makeupWorkRequestCall.revert(revertRow.id);
      await refetch();
      setRevertRow(null);
      toast.success("Đã hoàn tác đơn, đơn chuyển về Chưa duyệt");
    } catch (error) {
      console.error("Error:", error);
    }
    toast.dismiss(toastId);
  };

  const submitStatusApprove = async (data) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: dataApproveItem?.status,
      workingDayRate: data?.workingDayRate || 0,
    };
    if (dataApproveItem?.status !== "APPROVED") {
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
      toast.dismiss(toastEdit);
    } else {
      try {
        await makeupWorkRequestCall.approve(dataApproveItem?.id, dataFormat);
        await refetch();
        onCloseApprove();
        toast.success("Cập nhập trạng thái thành công");
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
      }
      toast.dismiss(toastEdit);
    }
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelect
                  isShowSearch={false}
                  options={statusDatas}
                  initialSelectedOption={{
                    key: null,
                    value: "Trạng thái",
                  }}
                  setValue={setStatus}
                />
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày tạo từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn người tạo",
                  }}
                  setValue={setEmployeeId}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "codeEmployee") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "auto";
                          textAlign = "start";
                        } else if (e.key === "nameEmployee") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "dayLeave") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "images") {
                          width = "10%";
                          textAlign = "center";
                        } else if (e.key === "note") {
                          width = "20%";
                          textAlign = "start";
                        } else if (e.key === "nameEmployeeConfirm") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "15%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                  p={0}
                                >
                                  <AiOutlineMore fontSize={"20px"} w="20px" />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  {e.status !== "APPROVED" && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() => handleOpenDelete(e?.edit)}
                                    >
                                      <Image src={icontrash} /> Xóa phiếu
                                    </MenuItem>
                                  )}
                                  {e.status === "REJECTED" && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() => setRevertRow(e)}
                                    >
                                      <Image src={iconBack} /> Hoàn tác đơn
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "codeEmployee") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "auto";
                                textAlign = "start";
                              } else if (keyvalue === "nameEmployee") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "dayLeave") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "images") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "note") {
                                width = "20%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "228px";
                              } else if (keyvalue === "nameEmployeeConfirm") {
                                width = "10%";
                                textAlign = "end";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "4",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.codeEmployee,
                                          submitStatus,
                                          e.id
                                        )
                                      : formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.codeEmployee
                                        )}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isEdit ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={dataEdit}
          refetch={refetch}
        />
      )}

      <FormApprove
        isOpen={isOpenApprove}
        onClose={onCloseApprove}
        defaultValues={dataEdit}
        refetch={refetch}
        onSubmit={submitStatusApprove}
      />

      <DeleteDialog
        isOpen={!!revertRow}
        onClose={() => setRevertRow(null)}
        title={"Hoàn tác đơn"}
        description={
          revertRow
            ? `Bạn có chắc chắn muốn đưa đơn làm bù của nhân viên ${revertRow.codeEmployee} - ${revertRow.nameEmployee} về trạng thái Chưa duyệt để duyệt lại không?`
            : ""
        }
        action={onRevert}
        textDelete={"Hoàn tác"}
        isDelete={false}
      />

      <DeleteDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        title={"Xóa phiếu"}
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn xóa phiếu này không?"
          </Flex>
        }
        action={() => onSubmitDelete()}
      />
    </>
  );
};

export default TableOpenMakeupWorkRequest;
